import { Share2 } from "lucide-react";
import { toast } from "sonner";

export default function ShareButton({ path, label = "Share", testid = "share-btn", title = "TP Quiz" }) {
  const share = async () => {
    const url = `${window.location.origin}${path}`;
    if (navigator.share) {
      try { await navigator.share({ title, url }); return; } catch (e) { if (e?.name === "AbortError") return; console.warn("Native share failed, copying instead", e); }
    }
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied! Send it to your class.");
    } catch {
      window.prompt("Copy this link:", url);
    }
  };
  return (
    <button onClick={share} data-testid={testid}
      className="inline-flex items-center gap-1 px-4 py-2 rounded-full border-[3px] border-[#374151] bg-white font-black text-sm shadow-[0_3px_0_0_#374151] active:translate-y-[3px] active:shadow-none">
      <Share2 size={16} strokeWidth={2.5} /> {label}
    </button>
  );
}
